import React from "react";
import _ from "lodash";
import { FormControl } from "react-bootstrap";
import autoBind from "react-autobind";
class PlayerPickerSelect extends React.PureComponent {

	constructor(props) {
		super(props);
		this.valueMap = {};
		autoBind(this);
	}

	onChange(event) {
		if (this.props.onChange) {
			const { value } = event.target;
			let _value = value;
			if (this.valueMap[value]) {
				_value = this.valueMap[value];
			}

			console.log("PlayerPickerSelect", _.isString(_value), _value);
			this.props.onChange(_value, event.target.options[event.target.selectedIndex].text);
		}
	}

	render() {
	
		const { item, options, disabled } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const pickerTheme = _.get(theme, "item.picker");
		const { basic:container, placeholder:placeholderStyles } = pickerTheme;
		this.valueMap = {};
		let entries = [];
		let placeholder = null;
		if (item.hasOwnProperty("pickerItemPlaceholder") && item.pickerItemPlaceholder !== "") {
			placeholder = this.props.item.pickerItemPlaceholder;
		} else {
			placeholder = "Select One...";
		}

		entries.push(<option style={placeholderStyles} value="" key={"option-placeholder"} label={placeholder} />);

		_.each(options, (pickerItem, idx) => {
			this.valueMap["" + pickerItem.value] = pickerItem.value;
			console.log("Adding value to picker", _.isString(pickerItem.value), pickerItem.value);
			entries.push(<option key={"option-" + pickerItem.value + "-" + idx} value={pickerItem.value}>{pickerItem.label}</option>);
		});

		let selectStyles = container;
		if (!item.value || item.value === "") {
			selectStyles = _.assign({}, selectStyles, placeholderStyles);
		}

		return <FormControl disabled={disabled} style={selectStyles} componentClass="select" value={item.value} onChange={this.onChange}>
			{entries}
		</FormControl>;
	}
}

export default PlayerPickerSelect;